import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { EPaymentEntity } from '../models/remita.model';
import { EPaymentProcessor } from 'projects/admin/src/app/dashboard/reports/tied-agent-accounts.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  protected override baseURL = `v1/payment/`;
  async checkout(arg: { referenceNumber: string; processor: EPaymentProcessor }) {
    const res = await lastValueFrom(
      this.post<{ message: string; code: string; data: { paymentLinkUrl: string } }>(
        {},
        `revop/checkout-link` + this.apiS.getRequestParse({ billNumber: arg.referenceNumber }),
      ),
    );

    const link = res.data.paymentLinkUrl;
    if (!link) {
      throw new Error('Payment link not generated');
    }
    location.href = link;
  }

  checkRevopPaymentStatus = (query: { billNumber: string; billerType: string }) =>
    this.get<{ code: '00' | string; message: string }>(`revop/status`, query);

  checkRRRIsPaid = (query: {
    rrr: string;
    billerType: EPaymentEntity;
    paymentProcessor: EPaymentProcessor;
  }) => {
    if (query.paymentProcessor === EPaymentProcessor.revPay) {
      return this.checkRevopPaymentStatus({ billNumber: query.rrr, billerType: query.billerType });
    }
    return this.get<{ code: '00' | string; message: string }>(`remita/status`, query);
  };
}
